module.exports = __webpack_public_path__ + "static/img/img.cd37abd1.jpg";